export default __webpack_public_path__ + "static/media/ais_bottom_logo@3x.b66ff2bf.webp";